export default __webpack_public_path__ + "static/media/GothamThinItalic.632acb55.otf";